import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { $$toast } from '@doger/ui/components/ui/toast';
import { useJWT } from '@doger/core/modules/auth';

type UseEmailConfirmationReminderOptions = {
  enabled?: boolean;

  onConfirmEmail?: () => void;
};

export const useEmailConfirmationReminder = ({
  enabled,
  onConfirmEmail,
}: UseEmailConfirmationReminderOptions = {}) => {
  const jwt = useJWT();
  const { t } = useTranslation('core');

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!jwt) {
      return;
    }

    if (!jwt.isConfirmed) {
      const ref = {
        current: undefined as number | string | undefined,
      };

      const timeoutId = setTimeout(() => {
        ref.current = $$toast.warning(
          t('auth.emailConfirmationReminder.title'),
          {
            description: t('auth.emailConfirmationReminder.description'),
            duration: 60_000,

            action: {
              label: t('auth.emailConfirmationReminder.actionLabel'),
              onClick: () => onConfirmEmail?.(),
            },
          }
        );
      }, 1000);

      return () => {
        clearTimeout(timeoutId);

        if (ref.current !== undefined) {
          $$toast.dismiss(ref.current);
        }
      };
    }
  }, [jwt, enabled, t]);
};
